import React, { Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Code-split each route so visitors only download the JS for the page they open.
const Home = lazy(() => import("./pages/Home"));
const JobOp = lazy(() => import("./pages/JobOp"));
const Disney = lazy(() => import("./pages/Disney"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Activities = lazy(() => import("./pages/Activities"));
const Tamwood = lazy(() => import("./pages/Tamwood"));
const Contact = lazy(() => import("./pages/Contact"));

function App() {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";

  return (
    <div>
      <ScrollToTop />
      {!isDashboard && <Navbar />}
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/job-opportunity" element={<JobOp />} />
          <Route path="/disney" element={<Disney />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/tamwood" element={<Tamwood />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
      {!isDashboard && <Footer />}
    </div>
  );
}

export default App;
